module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"informe_perso":"informe personalizado","error_registro":"registrate o inicia sesión para descargarte el informe personalizado","nombre_informe":"nombre del informe","indicadores_explicacion":"seleccione la información que quiere que aparezca en el informe de descarga","informe_generado":"Informe generado","descargar":"descargar"}}')
  delete Component.options._Ctor
}
